module.exports = __webpack_public_path__ + "assets/img/1_905.5f8499b4.jpg";